const request = require('request');
const config = require('./config');

const getCondicoesPagamento = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': 'd67d8ab4f4c10bf22aa353e27879133c'
        },
        uri: `${config.API_NODE}/paymentConditions`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getListaCondicoes = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/condicoesPagamento/padrao`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getOneCondicao = (token, id) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/condicoesPagamento/${id}`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getListByCodPadrao = (token, id) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/condicoesPagamento/listByCodPadrao/${id}`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const postCondicao = (token, obj) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        timeout: 5500,
        uri: `${config.URL_BACKEND}/condicoesPagamento`,
        method: 'POST',
        body: JSON.stringify(obj)
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const putCondicao = (token, obj) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        timeout: 5500,
        uri: `${config.URL_BACKEND}/condicoesPagamento/${obj.Cd_pagto}`,
        method: 'PUT',
        body: JSON.stringify(obj)
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

module.exports = {
  getListaCondicoes,
  getOneCondicao,
  postCondicao,
  putCondicao,
  getCondicoesPagamento,
  getListByCodPadrao
};
